import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { campaigns, products, brands } from "data/actions";
import RaisedButton from "material-ui/RaisedButton";
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { Page, PageSection, PageBlock, RightDrawer } from "components/Page";
import Delete from "components/Buttons/Delete";
import Price from "components/Formaters/Price";

import Subheader from "material-ui/Subheader";
import Row from "components/Form/Row";
import MenuLink from "components/Navigation/MenuLink";
import * as os from "osutil";

import Field from "components/Form/Field";

class Campaign extends Component {
  state = {
    open: false
  };

  static contextTypes = {
    router: PropTypes.object
  };

  handleCancel(id) {
    this.context.router.history.push("/kampanj");
  }

  test = () => {
    //dispatch(showLoading())
  };

  componentWillMount() {
    this.props.actions.fetchBrands();
    this.props.actions.fetchProducts();
    this.props.actions.fetchCampaigns(this.props.user.accountid);
  }

  handleFormSubmit(event) {
    if (this.props.campaign.details.transactionId) {
      return;
    }
    var data = _.map(this.refs, (r, i) => {
      return { [i]: r.state.value || "" };
    });
    let merged = Object.assign(this.props.campaign.details, ...data);
    this.props.actions.updateCampaign(
      this.props.user.accountid,
      this.props.params.id,
      merged
    );
  }

  handleRemove = (bookingid, booking) => {
    if (this.props.campaign.details.transactionId) {
      return;
    }
    this.props.actions.removeFromCampaign(
      this.props.user.accountid,
      this.props.params.id,
      bookingid
    );
  };

  handleSendBooking = () => {

    if (this.props.campaign.details.transactionId) {
      return;
    }

    var data = _.map(this.refs, (r, i) => {
      return { [i]: r.state.value || "" };
    });
    data.status = "booked";
    let merged = Object.assign(this.props.campaign.details, ...data);
    merged.status = "booked";
    this.props.actions.updateCampaign(
      this.props.user.accountid,
      this.props.params.id,
      merged
    );
    this.setState({open: false});
    
  };

  renderEditions = (list, product) => {
    return _.map(list, (e, key) => {
      if (product && product.editions){
        var pe = product.editions[key];
        if (pe) {
          return (
            <span key={key} className="campaign_item_editions_item">
              {pe.number}
            </span>
          );
        }
      }
    });
  };
  renderBookings = () => {
    return _.map(this.props.campaign.bookings, (b, key) => {
      var p = this.props.products[b.productid];
      if (p) {
        var brand = this.props.brands[p.brandid];
        if (brand) {
          var pos = p.positions && p.positions && b && [b.positionid];
          return (
            <li key={key} className="campaign_item">
              <span className="campaign_item_header">
                <span className="campaign_item_product">{p.name}</span>
                <span className="campaign_item_brand_logo">
                  <img alt={brand.name} src={brand.logoUrl} />
                </span>
                {this.props.campaign.details.transactionId ? (
                  ""
                ) : (
                  <Delete handleClick={this.handleRemove.bind(this, key, b)} />
                )}
              </span>
              <span className="campaign_item_price">
              Media: {brand.name}
            </span>
            <span className="campaign_item_price">
                Pris: <Price value={p.netprice} />
              </span>
            <span className="campaign_item_position">
                Plats: {pos ? pos.value : "Ej spec"}
              </span>
              <span className="campaign_item_editions">
                Utgåvor: {this.renderEditions(b.editions, p)}
              </span>
            </li>
          );
        }
      }
    });
  };


  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };

  renderDialog = () =>
  {
    const actions = [
      <FlatButton
        label="Avbryt"
        onClick={this.handleClose}
      />,
      <FlatButton
        label="Skicka beställningen"
        primary={true}
        onClick={this.handleSendBooking}
      />,
    ];
    return (
      <Dialog
        title="Bekräfta bokning"
        actions={actions}
        modal={true}
        open={this.state.open}
      >
        Bekräfta bokningen genom att klicka på "Skicka beställningen".
      </Dialog>
    );
  }
  render() {
    if (
      !this.props.campaign ||
      !this.props.campaign.details ||
      !this.props.user
    ) {
      return null;
    }
    var total = this.props.campaign.amount
      ? this.props.campaign.amount
      : os.getTotalPrice(this.props.campaign, this.props.products);

    return [
      <RightDrawer key="brand_right">
        <PageBlock label="Kampanjer" />
      </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>
        <Subheader>
          <MenuLink label="Kampanjer" to="/kampanj" />
          <span className="pathsep" />
          <MenuLink
            label={this.props.campaign.details.name}
            to={this.props.params.id}
          />
        </Subheader>
        <div
          onSubmit={this.handleFormSubmit.bind(this)}
          className="form-inline"
        >
          <PageSection label="Kampanj">
            <Row>
              <Field
                ref="name"
                value={this.props.campaign.details.name}
                floatingLabelText="Namn"
              />
            </Row>
            <Row>
              <Field
                multiLine={true}
                ref="description"
                value={this.props.campaign.details.description}
                floatingLabelText="Anteckningar"
              />
            </Row>
            {total === 0 && (
              <Row styleName="padded">
                <RaisedButton
                  onTouchTap={this.handleFormSubmit.bind(this)}
                  primary={true}
                  label="Spara"
                />
                <RaisedButton
                  onTouchTap={this.handleCancel.bind(this)}
                  label="Stäng"
                />
              </Row>
            )}
          </PageSection>
          {total > 0 && (
            <div>
              <PageSection label="Bokningar">
                <Row>
                  <ul className="campaign_booking">{this.renderBookings()}</ul>
                </Row>
              </PageSection>
              <PageSection label="Total">
                <Row>
                  <div style={{ flex: "1 1" }}>
                    <hr />
                    <h2>
                      <Price value={total} />
                    </h2>
                  </div>
                </Row>
                <Row styleName="padded">
                  {this.props.campaign.details.status === "draft" && !this.props.campaign.details.transactionId && (
                    <RaisedButton
                      onTouchTap={this.handleOpen}
                      primary={true}
                      label="Skicka beställnig"
                    />
                  )}
                  <RaisedButton
                    onTouchTap={this.handleFormSubmit.bind(this)}
                    primary={true}
                    label="Spara"
                  />
                  <RaisedButton
                    onTouchTap={this.handleCancel.bind(this)}
                    label="Stäng"
                  />
                </Row>
              </PageSection>
            </div>
          )}
        </div>
        {this.renderDialog()}
      </Page>
    ];
  }
}

function mapStateToProps(state, ownProps) {
  if (
    !state.campaigns.list.data ||
    !state.brands.list.data ||
    !state.auth.user
  ) {
    return { pending: true };
  }
  return {
    campaign: state.campaigns.list.data[ownProps.params.id],
    user: ownProps.user,
    products: state.products.list.data,
    brands: state.brands.list.data,
    pending: state.campaigns.list.pending
  };
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(
      { ...products, ...campaigns, ...brands },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatch)(Campaign);



// WEBPACK FOOTER //
// ./src/pages/campaigns/Campaign.jsx